import '../lib/js/select2.min';



jQuery(document).ready(function ($) {
    window.addEventListener('message', function(event) {
        if (event.data.type === 'hsFormCallback') {
            const {eventName, id, data} = event.data;

            // Track form readiness
            if (eventName === 'onFormReady') {
                const countriesSelect = $(".become-distributor__title");
                $('.hs-input.hs-fieldtype-intl-phone select').select2({
                    templateResult: formatOption,
                    templateSelection: formatOption,
                    minimumResultsForSearch: -1
                });

                function formatOption(option) {
                    if (!option.id) {
                        return option.text;
                    }

                    const $container = $('<span></span>');
                    $container.addClass('select-flag-icon fi fib fi-' + option.element.value.toLowerCase());
                    return $container;
                };
            }
        }
    });
});
